import React from 'react';
import Colors from '../../Constant/Colors';
import '../Footer/Footer.css';
import { Row, Col } from 'react-bootstrap';
import InstagramOutlined from '@mui/icons-material/Instagram';
import TwitterOutlined from '@mui/icons-material/Twitter';
import FacebookOutlined from '@mui/icons-material/FacebookOutlined';

const Footer = () => {
  return (
    <>
      <svg viewBox="0 0 1440 320">
        <path
          fill="#7FFFD4"
          fill-opacity="1"
          d="M0,160L80,160C160,160,320,160,480,186.7C640,213,800,267,960,261.3C1120,256,1280,192,1360,160L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
      </svg>
      <div className="footer">
        <div>
          <div className="footer-content">
            <h3
              style={{
                fontFamily: 'Trebuchet MS',
                fontSize: '3.2em',
                color: Colors.primary,
                marginLeft: 60,
                letterSpacing:3
              }}>
              IconicArt 
            </h3>
            <span style={{marginLeft:60,fontSize:18}} >Developed by <b>Hardik Panwar</b></span>
            <div className="sub">
              <Row>
                <Col lg={4}>
                  <InstagramOutlined style={{ color:Colors.primary , fontSize: 34,marginLeft:20 }} />
                </Col>
                <Col lg={4}>
                  <TwitterOutlined style={{ color: Colors.primary, fontSize: 34,marginLeft:20 }} />
                </Col>
                <Col lg={4}>
                  <FacebookOutlined style={{ color: Colors.primary, fontSize: 34,marginLeft:20 }}/>
                </Col>
              </Row>
            </div>
            <div
              style={{
                textAlign: 'center',
                marginTop: 50,
                backgroundColor: Colors.primary,
                padding: 20,
                color: 'white',
              }}>
              {' '}
              @copyright 2023
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
